<template>
  <div id="app">
    <Navigation />
  </div>
</template>

<script>
  const Navigation = () =>
    import(/* webpackChunkName: "Navigation" */ '../src/components/Navigation');

  export default {
    components: { Navigation },
  };
</script>

<style>
  @import 'assets/fonts.css';

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    background-color: black;
    color: white;
    font-family: 'Fira Sans Extra Condensed', sans-serif;
  }
</style>
